/**
 * Rubros para Servicios (labels canónicas; ver SERVICIOS_PLAN.md anexo).
 * `id` estable para filtros; `label` para UI y búsqueda.
 */
export const CATEGORIAS_SERVICIOS = [
  { id: 'mecanica_integral', label: 'Mecánica Integral' },
  { id: 'gomeria_alineacion', label: 'Gomería y Alineación' },
  { id: 'chapa_pintura', label: 'Chapa y Pintura' },
  { id: 'electricidad_automotor', label: 'Electricidad del Automotor' },
  { id: 'lavadero_detailing', label: 'Lavadero de Autos / Detailing' },
  { id: 'electricista', label: 'Electricista' },
  { id: 'plomero', label: 'Plomero' },
  { id: 'gasista_matriculado', label: 'Gasista Matriculado' },
  { id: 'aire_acondicionado', label: 'Instalación de Aire Acondicionado' },
  { id: 'pintura_revestimientos', label: 'Pintura y Revestimientos' },
  { id: 'construccion_seco', label: 'Construcción en Seco / Durlock' },
  { id: 'albanileria_reformas', label: 'Albañilería y Reformas' },
  { id: 'cerrajeria_24', label: 'Cerrajería 24hs' },
  { id: 'herreria_obra', label: 'Herrería de Obra' },
  { id: 'vidrieria', label: 'Vidriería' },
  { id: 'jardineria', label: 'Jardinería y Desmalezado' },
  { id: 'limpieza_piletas', label: 'Limpieza de Piletas' },
  { id: 'limpieza_casas', label: 'Limpieza de Casas y Oficinas' },
  { id: 'fumigacion', label: 'Fumigación y Control de Plagas' },
  { id: 'electrodomesticos', label: 'Reparación de Electrodomésticos' },
  { id: 'tapiceria', label: 'Tapicería y Restauración de Muebles' },
  { id: 'barberia', label: 'Barbería y Peluquería' },
  { id: 'manicuria', label: 'Manicuría y Estética' },
  { id: 'masajes_kinesio', label: 'Masajes y Kinesiología' },
  { id: 'personal_trainer', label: 'Personal Trainer / Yoga' },
  { id: 'enfermeria_domicilio', label: 'Enfermería a Domicilio' },
  { id: 'clases_particulares', label: 'Clases Particulares / Apoyo Escolar' },
  { id: 'ninera', label: 'Cuidado de Niños / Niñera' },
  { id: 'adultos_mayores', label: 'Cuidado de Adultos Mayores' },
  { id: 'paseador_perros', label: 'Paseador de Perros / Adiestramiento' },
  { id: 'peluqueria_canina', label: 'Peluquería Canina' },
  { id: 'fletes_mudanzas', label: 'Fletes y Mudanzas' },
  { id: 'soporte_pc_cel', label: 'Soporte Técnico PC y Celulares' },
  { id: 'camaras_alarmas', label: 'Cámaras de Seguridad y Alarmas' },
  { id: 'costurera', label: 'Costurera / Arreglo de Ropa' },
];

const ID_SET = new Set(CATEGORIAS_SERVICIOS.map((c) => c.id));

/** @param {string} id */
export function esRubroServicioValido(id) {
  return ID_SET.has(String(id || '').trim());
}

export function labelRubroServicio(id) {
  const row = CATEGORIAS_SERVICIOS.find((c) => c.id === id);
  return row?.label || String(id || '');
}
